import { render, staticRenderFns } from "./MasrafForm.vue?vue&type=template&id=37b51845"
import script from "./MasrafForm.vue?vue&type=script&lang=ts"
export * from "./MasrafForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports